/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import Promise from './Promise';

export default class PromiseHandler<T> {
  onFulfilled: Function | null;
  onRejected: Function | null;
  promise: Promise<T>;

  constructor(onFulfilled: Function, onRejected: Function, promise: Promise<T>) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }
}